import { Card } from 'antd';
import './success.styles.less';

export const CheckinSuccess = () => (
  <div className="success">
    <h1 className="logo">32Co.</h1>
    <Card style={{ width: 360 }} bordered={false}>
      <div className="success-message-container">
        {/* <div className="title-container p-mb-4"> */}
        <span className="title">Treatment Check In</span>
        <div className="half-border" />
        {/* </div> */}
        <p className="content mt-3">You have successfully submitted your treatment check-in.</p>
        {/* <Button type="primary" size="large" style={{minWidth: 180}} className="p-mt-3">
                        <Link to="/signin">LOGIN</Link>
                    </Button> */}
      </div>
    </Card>
  </div>
);
